export const selectedItem = (payload, closing) => ({
  type: 'SELECTED_ITEM',
  payload,
  closing,
});

export const clearItem = () => ({
  type: 'CLEAR_ITEM',
});
